import { useTranslation } from "react-i18next";
import {
  ContactDetailsSectionBreadcrumbs,
  ContactDetailsSectionBreadcrumbsProps,
} from "../ContactDetailsSectionBreadcrumbs";
import { ContactDetailsSections } from "../../../ContactsDialog";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { useMemo, useState } from "react";
import { CloudUpload } from "lucide-react";

export interface MedicationsSectionProps {
  enduser: TellescopeModelFromName<"endusers">;
}

export const MedicationsSection = ({ enduser }: MedicationsSectionProps) => {
  const [showUploadMedications, setShowUploadMedications] = useState(false);
  const { t } = useTranslation("contacts");

  const { breadcrumbs, actionButtons } = useMemo<
    Pick<ContactDetailsSectionBreadcrumbsProps, "breadcrumbs" | "actionButtons">
  >(() => {
    const breadcrumbs: ContactDetailsSectionBreadcrumbsProps["breadcrumbs"] = [
      {
        title: t("Medications"),
        onClick: showUploadMedications ? () => setShowUploadMedications(false) : undefined,
      },
    ];
    if (showUploadMedications) {
      breadcrumbs.push({ title: t("contacts.section.uploadMedications") });
    }

    const actionButtons: ContactDetailsSectionBreadcrumbsProps["actionButtons"] = showUploadMedications
      ? undefined
      : [
          {
            hoverLabel: t("contacts.section.uploadMedications"),
            onClick: () => setShowUploadMedications(true),
            icon: CloudUpload,
          },
        ];

    return { breadcrumbs, actionButtons };
  }, [showUploadMedications, t]);

  return (
    <div className="flex flex-col gap-4 overflow-y-hidden">
      <ContactDetailsSectionBreadcrumbs
        enduserId={enduser.id}
        breadcrumbs={breadcrumbs}
        actionButtons={actionButtons}
      />
      {showUploadMedications ? (
        <ContactDetailsSections.MedicationUploadForm
          contact={enduser}
          onUpload={() => setShowUploadMedications(false)}
        />
      ) : (
        <ContactDetailsSections.MedicationsSection contact={enduser} />
      )}
    </div>
  );
};
